import { SelectItem } from 'primeng/api';

export class AccelaControl{
  name: string;
  type: AccelaControlType;
  display: boolean;
  required: boolean;
  readOnly: boolean;
  hidden = false;
  defaultLabel: string;
  label: string;
  tooltip: string;
  placeholder: string;
  options: SelectItem[];
  optionKey: string;
  mask: string;
  maxLength: number;
  value: any;
  templateField: boolean;
  isDBRequired: boolean;
}

export enum AccelaControlType{
  Blocked,
  Checkbox,
  Dropdown,
  Date,
  Email,
  FEIN,
  Password,
  Phone,
  RadioGroup,
  SSN,
  Textbox,
  Zip,
  Number,
  Separator,
  Time,
  TextArea,
  Money
}
